var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.775 20.6496H4.5C4.1 20.6496 3.75 20.4996 3.45 20.1996C3.15 19.8996 3 19.5496 3 19.1496V4.59961C3 4.19961 3.12917 3.84961 3.3875 3.54961C3.64583 3.24961 3.86667 3.09961 4.05 3.09961H9.1C9.21667 2.51628 9.50417 2.03711 9.9625 1.66211C10.4208 1.28711 10.95 1.09961 11.55 1.09961C12.15 1.09961 12.6792 1.28711 13.1375 1.66211C13.5958 2.03711 13.8833 2.51628 14 3.09961H19.05C19.45 3.09961 19.8 3.24961 20.1 3.54961C20.4 3.84961 20.55 4.19961 20.55 4.59961V9.67461H19.05V4.59961H16.4V7.84961H7.15V4.59961H4.5V19.1496H10.775V20.6496ZM12 4.49961C12.2833 4.49961 12.5208 4.40378 12.7125 4.21211C12.9042 4.02044 13 3.78294 13 3.49961C13 3.21628 12.9042 2.97878 12.7125 2.78711C12.5208 2.59544 12.2833 2.49961 12 2.49961C11.7167 2.49961 11.4792 2.59544 11.2875 2.78711C11.0958 2.97878 11 3.21628 11 3.49961C11 3.78294 11.0958 4.02044 11.2875 4.21211C11.4792 4.40378 11.7167 4.49961 12 4.49961Z",
    fill: "#3360AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16.0254L15.5 20.0254L22.55 12.9754L21.475 11.9004L15.5 17.8754L12.575 14.9504L11.5 16.0254Z",
    fill: "#208C72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderCheck);
export default __webpack_public_path__ + "static/media/order-check.231d8b8cd155dba064543af40593d4ac.svg";
export { ForwardRef as ReactComponent };